export default __webpack_public_path__ + "static/media/ic_insurance.92b20702.svg";